import React from "react";

const Order = () => {
  return (
    <div className="w-full">
      <table>
        <thead>
          <tr>
            <td>Order Id</td>
            <td>Dates</td>
            <td>Status</td>
            <td>Price</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>#121</td>
            <td>October 11, 2024</td>
            <td>Delivered</td>
            <td>₹1234.00</td>
          </tr>
          <tr>
            <td>#121</td>
            <td>October 11, 2024</td>
            <td>Delivered</td>
            <td>₹1234.00</td>
          </tr>
          <tr>
            <td>#121</td>
            <td>October 11, 2024</td>
            <td>Delivered</td>
            <td>₹1234.00</td>
          </tr>
          <tr>
            <td>#121</td>
            <td>October 11, 2024</td>
            <td>Delivered</td>
            <td>₹1234.00</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Order;
